import { useContext } from 'react';
import MatrixUnreadEventsContext from './context';

const useMatrixUnreadEventsContext = () => {
  const context = useContext(MatrixUnreadEventsContext);

  return context;
};

export { useMatrixUnreadEventsContext };
